import { Navigate } from 'react-router-dom';
import { useUserRole } from '@/hooks/useUserRole';

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  requiredRole: 'admin' | 'moderator' | 'admin-or-moderator';
}

export default function RoleProtectedRoute({ children, requiredRole }: RoleProtectedRouteProps) {
  const { data: role, isLoading } = useUserRole();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-hero">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Verifying access...</p>
        </div>
      </div>
    );
  }

  // Check role authorization
  const isAuthorized = 
    requiredRole === 'admin-or-moderator' 
      ? (role === 'admin' || role === 'moderator')
      : role === requiredRole;

  if (!isAuthorized) {
    // Return 404 to avoid exposing admin routes
    return <Navigate to="/404" replace />;
  }

  return <>{children}</>;
}
